import { useEffect } from "react";

let activeLockCount = 0;
let previousOverflow = "";
let previousPaddingRight = "";

function lockBodyScroll() {
  if (typeof document === "undefined") return;

  if (activeLockCount === 0) {
    const body = document.body;
    previousOverflow = body.style.overflow;
    previousPaddingRight = body.style.paddingRight;

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    body.style.overflow = "hidden";

    if (scrollbarWidth > 0) {
      const currentPaddingRight = Number.parseFloat(window.getComputedStyle(body).paddingRight) || 0;
      body.style.paddingRight = `${currentPaddingRight + scrollbarWidth}px`;
    }
  }

  activeLockCount += 1;
}

function unlockBodyScroll() {
  if (typeof document === "undefined" || activeLockCount === 0) return;

  activeLockCount -= 1;

  if (activeLockCount === 0) {
    const body = document.body;
    body.style.overflow = previousOverflow;
    body.style.paddingRight = previousPaddingRight;
  }
}

export default function useBodyScrollLock(locked) {
  useEffect(() => {
    if (!locked) return undefined;

    lockBodyScroll();
    return () => unlockBodyScroll();
  }, [locked]);
}